import {Card, CardContent, Grid} from "@mui/material";

const CardContainer = ({children}: { children: JSX.Element }) => {

    return (
        <Grid container spacing={2} p={2}>
            <Grid item xs={12} sm={12}>
                <Card>
                    <CardContent>
                        <Grid item xs={12}>
                            {children}
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};

export default CardContainer;